module.exports = __webpack_public_path__ + "img/timeoutVIPbg.4a12ded8.svg";